import { monday } from '../../platformSpecific/monday';

const getMyself = async () => {
  const response = await monday.api(
    `query {
      me {
        id
        name
        photo_tiny
        photo_thumb
      }
    }`
  );
  return response.data.me;
};

const getUsers = async () => {
  const response = await monday.api(
    `query {
      users {
        id
        name
        photo_tiny
        photo_thumb
      }
    }`
  );
  return response.data.users;
};

const getUsersById = async (userIds) => {
  const response = await monday.api(
    `query {
      users (ids: [${userIds.join(', ')}]) {
        id
        name
        photo_tiny
        photo_thumb
      }
    }`
  );
  return response.data.users;
};

export { getMyself, getUsers, getUsersById };
